/// <reference types="sharepoint" />
import { Injectable, ChangeDetectorRef } from '@angular/core';
import { Languages } from '../models/enums.model';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AuthenticationService } from '../../front-user/shared/services/authentication.service';
import { AppConfig } from './app.config';
import { FormControl } from '@angular/forms';
declare var $: any;
import * as CryptoJS from 'crypto-js';

@Injectable({ providedIn: 'root' })

export class GlobalServices {
    public Languages: any = Languages;
    public user: User;
    public isLoaderEnabled: boolean = false;
    public historyData = [];
    public myRequestsSearchCriteria = [];
    public shipyardSearchCriteria = [];
    public longHaulReportSearchCriteria = [];
    public eBookingReportSearchCriteria = [];
    public myTasksSortsndPagingCriteria = [];
    public smallunitsReportSearchCriteria = [];
    public CrewChangeReportSearchCriteria = [];
    public circularsReportSearchCriteria = [];
    public ReleaseReportSearchCriteria = [];


    constructor(private authSrevice: AuthenticationService) {
        this.user = authSrevice.currentUserValue;
          //this.getSimulatedCurrentUser();
    }

    public set IsLoaderEnabled(value) {
        this.isLoaderEnabled = value;
    }
    public get IsLoaderEnabled(): boolean {
        return this.isLoaderEnabled;
    }
    public getLanguage() {
       if (_spPageContextInfo.currentUICultureName == "ar-SA") {
           return Languages.Arabic;
        }
        return Languages.English;
         // return Languages.English;
        //return Languages.Arabic;

    }
    //abdelrahman.shaker@emailna.co - UserId:3557062F-9C5B-4AE7-86A0-244F88B3C42Ba
    //ghada.comp@gmail.com - UserId:EF8D717A-338C-4439-8C26-42E130339197
    getSimulatedCurrentUser() {
        this.user = {
            //"UserId": "",
            //"UserName": "Alaa.Emam@linkdev.com",
            //"UserName": "ahmed.abdelgwad@linkdev.com",
            "UserId": "F360FF95-C800-4502-9676-EC64771FC5BA",
            "UserName": "ahmedmagdy.fcih12@gmail.com",
            "Password": null,
            "RegisterTypeId": 1,
            "FullName": "Admin",
            "Address": "test11111",
            "CountryId": 1,
            "Mobile": "+20033669988",
            "Fax": "1111",
            "Organization": "test111111",
            "Email": "ahmed.abdelgwad@linkdev.com",
            "ConfrimPassword": null,
            "IsAdmin": false,
            "role": null,
            "PortalUser": null,
            "Agent": null,
            "Supplier": null,
            "recaptcha": null,
            "RequestId": null,
            "Phone1": "01282886910",
            "Name": "test",
            "Phone": "01282886910",
            "CompanyName": ""
        };
    }
    goToHome(): void {
        if (this.getLanguage() == Languages.Arabic)
            window.location.href = AppConfig.settings.apiServer.HomeAR;
        else
            window.location.href = AppConfig.settings.apiServer.HomeEN;
    }
    goToWorkSpace(): void {
        if (this.getLanguage() == Languages.Arabic)
            window.location.href = AppConfig.settings.apiServer.WorkspaceAR;
        else
            window.location.href = AppConfig.settings.apiServer.WorkspaceEN;
    }
    //#region  generic validations
    public noWhitespaceValidator(control: FormControl) {
        const isWhitespace = (control.value || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { required: true };
    }
    //#endregion
    encryptPassword(password) {
        var text = CryptoJS.enc.Utf8.parse(password);
        var Key = CryptoJS.enc.Utf8.parse(AppConfig.settings.apiServer.AESSecretKey); //secret key
        var IV = CryptoJS.enc.Utf8.parse(AppConfig.settings.apiServer.AESIVKey); //16 digit IV key
        var encryptedText = CryptoJS.AES.encrypt(text, Key, { keySize: 128 / 8, iv: IV, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString();
        return encryptedText;
    }
}
